const status = [
    { "value": "command", "color": "#CBD5E1", "backgroundColor": "#F1F5F9", "textColor": "#000000" },          // Gris clair (pastel)
    { "value": "in_warehouse", "color": "#4ADE80", "backgroundColor": "#BBF7D0", "textColor": "#000000" },     // Vert pastel
    { "value": "out_of_warehouse", "color": "#F87171", "backgroundColor": "#FECACA", "textColor": "#000000" }, // Rouge pastel
    { "value": "under_maintenance", "color": "#FACC15", "backgroundColor": "#FEF9C3", "textColor": "#000000" },// Jaune pastel
    { "value": "out_of_order", "color": "#475569", "backgroundColor": "#E2E8F0", "textColor": "#000000" },     // Gris bleuté clair
    { "value": "sold", "color": "#9CA3AF", "backgroundColor": "#F3F4F6", "textColor": "#000000" },             // Gris très clair
    { "value": "destroyed", "color": "#334155", "backgroundColor": "#E2E8F0", "textColor": "#000000" }         // Gris bleuté clair
];

const getColor = function (value) {
    return status.find((item) => item.value === value)?.color ?? null;
}

const getBackgroundColor = function (value) {
    return status.find((item) => item.value === value)?.backgroundColor ?? null;
}

const getTextColor = function (value) {
    return status.find((item) => item.value === value)?.textColor ?? null;
}

export {
    status,
    getColor,
    getBackgroundColor,
    getTextColor
};